module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-top.6d463759.svg";